import(/* webpackMode: "eager", webpackExports: ["MessengerLandingClient"] */ "/app/apps/frontend/components/messenger-landing-client.tsx");
